// Libs
import React, { Component } from 'react'
import Select from 'react-select';

// Styles
import './Options.css'
import 'react-select/dist/react-select.css';

// components
import OptionName from './OptionName'
import OptionValue from './OptionValue'


class Options extends Component {

  constructor(props) {
    super(props)
    this.state = {

    }
    this.arrowRenderer = this.arrowRenderer.bind(this)
  }

  arrowRenderer() {
    return (
      <span>+</span>
    )
  }



  render() {


    return (
      <div className="select-control">

        <Select
          arrowRenderer={this.arrowRenderer}
          onChange={this.props.handleChange}
          optionComponent={OptionName}
          options={this.props.data}
          placeholder={
            <span>
              <i className={this.props.data[this.props.carousel.index].content.icon} aria-hidden="true"></i>
              {this.props.data[this.props.carousel.index].label}
            </span>
          }
          value={this.props.value}
          clearable={true}
          valueComponent={OptionValue}
          />
      </div>
    )
  }

}

export default Options;



/** WEBPACK FOOTER **
 ** ./src/components/pages/Options.js
 **/